import { useLazyQuery } from '@apollo/client/react';

import {
  TerminalAndGroupOptionsDocument,
  type TerminalAndGroupOptionsQueryResult,
  type TerminalAndGroupOptionsQueryVariables
} from '../graphql';
import { withGroupMembersAsOptions } from '../helpers';
import type { LoadTerminalAndGroupOptions, TerminalOrGroup, TerminalOrGroupOption } from '../types';

const useTerminalAndGroupOptions = (includeGroups: boolean): LoadTerminalAndGroupOptions => {
  const [fetchTerminalsAndGroups] = useLazyQuery<TerminalAndGroupOptionsQueryResult, TerminalAndGroupOptionsQueryVariables>(
    TerminalAndGroupOptionsDocument
  );

  return async (query: string): Promise<TerminalOrGroupOption[]> => {
    const response = await fetchTerminalsAndGroups({ variables: { includeGroups, query } });
    const fetchedOptions: TerminalOrGroup[] = response?.data?.transportTerminalsAndGroups?.nodes ?? [];

    return withGroupMembersAsOptions(fetchedOptions);
  };
};

export default useTerminalAndGroupOptions;
